import clientIndexRouter from './modules/clientIndex';

const indexManageRuoter = [].concat(clientIndexRouter)

export default indexManageRuoter